import { el, mount, unmount } from 'redom';

class DeleteButton {

  constructor(configuration) {

    this.label = configuration.label || 'Delete';
    this.onClick = configuration.onClick;

    this.spinner = this.renderSpinner();

    this.el = el('button', {
      type: 'button',
      id: configuration.id,
      class: 'delete-button ' + (configuration.class || ''),
      onclick: this.handleClickEvent.bind(this)
    }, this.label);

  }

  renderSpinner() {

    return el('ht-spinner', { size: 'tiny' });

  }

  async handleClickEvent(event) {

    this.setWorking();

    await this.onClick(event);

    this.setIdle();

  }

  setWorking() {

    this.el.textContent = '';
    mount(this.el, this.spinner);

  }

  setIdle() {

    this.el.textContent = this.label;
    unmount(this.el, this.spinner);

  }

  update(configuration) {

    this.el.textContent = configuration.label;

  }

}

export default DeleteButton;